module.exports = __webpack_public_path__ + "static/media/ProfileCreated.ccb43ade.png";